import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

export default function Settings({
  integrationId,
  saveIntegration,
  channelDetails,
  existingSettings = {},
}) {
  const [settings, setSettings] = useState(channelDetails.settings || {
    clientId: '',
    clientSecret: '',
    tenantId: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (existingSettings && Object.keys(existingSettings).length > 0) {
      setSettings({
        clientId: existingSettings.clientId || '',
        clientSecret: existingSettings.clientSecret || '',
        tenantId: existingSettings.tenantId || '',
      });
    }
  }, [existingSettings]);

  const handleChange = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    let detailts = channelDetails || {};
    detailts.settings = settings;
    saveIntegration({ channelDetails: detailts });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Register App in Microsoft Entra ID</h6>
        </div>
        <Separator className="mx-3" />
        <Card className="p-4 m-4">
          <Card className="py-4 px-2 mb-3">
            <Col md={12}>
              <ol style={{ listStyle: 'none' }}>
                <li style={{ marginBottom: 12, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 1: Register app in Microsoft Entra ID</span>
                  <ul style={{ marginTop: 5, paddingLeft: 50, lineHeight: 1.5 }}>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Go to <span style={{ fontWeight: 500 }}>Entra ID → App registrations</span></li>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Create a new app named <span style={{ fontWeight: 500 }}>email-automation</span></li>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Add API permissions (Application type): <span style={{ fontWeight: 500 }}>Mail.ReadWrite</span> and <span style={{ fontWeight: 500 }}>Mail.Send</span></li>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Under <span style={{ fontWeight: 500 }}>Certificates & secrets</span>, create a new client secret named <span style={{ fontWeight: 500 }}>email-automation-secret</span></li>
                    <li style={{ marginBottom: 0, fontSize: 14 }}>Copy the <span style={{ fontWeight: 500 }}>Tenant ID</span>, <span style={{ fontWeight: 500 }}>Client ID</span>, and <span style={{ fontWeight: 500 }}>Client Secret</span> to add them below in Step 4.</li>
                  </ul>
                </li>
                <li style={{ marginBottom: 12, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 2: Create Application Access Policy </span>
                  <span style={{ fontWeight: 'normal', color: '#888', fontSize: 14 }}>(optional but recommended)</span>
                  <ul style={{ marginTop: 5, paddingLeft: 50, lineHeight: 1.5 }}>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>This step restricts the app to access only specific mailboxes.</li>
                    <li style={{ marginBottom: 4, fontSize: 14, fontWeight: 500 }}>Create security group:</li>
                    <ul style={{ paddingLeft: 20, marginBottom: 8 }}>
                      <li style={{ fontSize: 14 }}>Choose group name like <span style={{ fontWeight: 500 }}>email-automation-group</span></li>
                      <li style={{ fontSize: 14 }}>Primary SMTP Address can be any email address, make sure domain matches yours.</li>
                    </ul>
                    <pre style={{ background: '#f8f9fa', padding: '12px', borderRadius: '6px', fontSize: 13, marginBottom: 12, border: '1px solid #e3e6ed', lineHeight: 1.5 }}>
                      {`New-DistributionGroup\n    -Name <email-automation-group>\n    -Type Security\n    -PrimarySmtpAddress "emailautomation@langhamhotels.com"`}
                    </pre>

                    <li style={{ marginBottom: 4, fontSize: 14, fontWeight: 500 }}>Add members to the group:</li>
                    <ul style={{ paddingLeft: 20, marginBottom: 8 }}>
                      <li style={{ fontSize: 14 }}>Use the group name from previous step</li>
                      <li style={{ fontSize: 14 }}>Run for all the email addresses that you want to include in email automation e.g. <span style={{ fontWeight: 500 }}>reservations@mybrand.com</span></li>
                    </ul>
                    <pre style={{ background: '#f8f9fa', padding: '12px', borderRadius: '6px', fontSize: 13, marginBottom: 12, border: '1px solid #e3e6ed', lineHeight: 1.5 }}>
                      {`Add-DistributionGroupMember\n    -Identity <email-automation-group>\n    -Member reservations@mybrand.com`}
                    </pre>

                    <li style={{ marginBottom: 4, fontSize: 14, fontWeight: 500 }}>Test the access:</li>
                    <ul style={{ paddingLeft: 20, marginBottom: 8 }}>
                      <li style={{ fontSize: 14 }}>Run this command to test the access for all emails</li>
                    </ul>
                    <pre style={{ background: '#f8f9fa', padding: '12px', borderRadius: '6px', fontSize: 13, marginBottom: 12, border: '1px solid #e3e6ed', lineHeight: 1.5 }}>
                      {`Test-ApplicationAccessPolicy\n    -Identity reservations@mybrand.com\n    -AppId <your-app-id>`}
                    </pre>

                    <li style={{ marginBottom: 4, fontSize: 14, fontWeight: 500 }}>Create application access policy:</li>
                    <ul style={{ paddingLeft: 20, marginBottom: 8 }}>
                      <li style={{ fontSize: 14 }}>Create this policy by replacing the group. Run the following PowerShell command:</li>
                    </ul>
                    <pre style={{ background: '#f8f9fa', padding: '12px', borderRadius: '6px', fontSize: 13, marginBottom: 0, border: '1px solid #e3e6ed', lineHeight: 1.5 }}>
                      {`New-ApplicationAccessPolicy\n   -AppId <your-app-id>\n   -PolicyScopeGroupId <email-automation-group>\n   -AccessRight RestrictAccess\n   -Description "Restrict to defined mailboxes"`}
                    </pre>
                  </ul>
                </li>
                <li style={{ marginBottom: 12, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 3: Add your mailbox to the group</span>
                </li>
                <li style={{ marginBottom: 12, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 4: Add credentials</span>
                  <ul style={{ marginTop: 5, paddingLeft: 50, lineHeight: 1.5 }}>
                    <li style={{ fontSize: 14 }}>Paste the values from Step 1 below:</li>
                  </ul>
                </li>
              </ol>
            </Col>
          </Card>
          <Card className="p-4">
            <Row form>
              <Col md={12}>
                <h5 className="mb-3">App Registration Information</h5>
                <FormGroup>
                  <Label for="clientId">Client ID</Label>
                  <Input
                    type="text"
                    name="clientId"
                    id="clientId"
                    placeholder="Enter Azure Client ID"
                    value={settings.clientId}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="clientSecret">Client Secret</Label>
                  <Input
                    type="text"
                    name="clientSecret"
                    id="clientSecret"
                    placeholder="Enter Azure Client Secret"
                    value={settings.clientSecret}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup className="mb-0">
                  <Label for="tenantId">Tenant ID</Label>
                  <Input
                    type="text"
                    name="tenantId"
                    id="tenantId"
                    placeholder="Enter Azure Tenant ID"
                    value={settings.tenantId}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Card>
        </Card>
        <Separator className="mb-3" />
        <Colxx md="12" className="text-center py-2">
          <Button
            color="primary"
            size="xs"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Colxx>
      </CardBody>
    </Card>
  );
}